module.exports = __webpack_public_path__ + "static/logo_mobile-815ba5b3027bddf390fde42cebd88c91.svg";